import { render } from "./Piturim.vue?vue&type=template&id=0cacd5b2&scoped=true"
import script from "./Piturim.vue?vue&type=script&lang=js"
export * from "./Piturim.vue?vue&type=script&lang=js"

import "./Piturim.vue?vue&type=style&index=0&id=0cacd5b2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cacd5b2"]])

export default __exports__